import Vue from "vue";

const CardItemProps = Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },

    image: {
      type: String,
      required: true,
    },

    value: {
      type: Number,
      required: true,
    },

    url: {
      type: String,
      required: true,
    },

    code: {
      type: String,
      required: true,
    },
  },
});

export default CardItemProps;
